import Config from "../config";
import React from "react";
import {useGlobal} from "reactn";

const Picture = ({user = {}, group = false, picture, title = "Group"}) => {

    const brand = useGlobal('brand')[0];

    if (group) {
        if (picture)
            return <img src={`${Config.url || ''}/api/images/${picture.shieldedID}/256/${brand}`} alt="Picture 1" className="picture"/>;
        else
            return <div className="img">{title.substr(0,1).toUpperCase()}</div>;
    }

    let firstName = user.firstName || "User";
    let lastName = user.lastName || "Name";
    if (user.picture)
        return <img src={`${Config.url || ''}/api/images/${user.picture.shieldedID}/256/${brand}`} alt="Picture 1" className="picture"/>;
    else
        return <div className="img">{firstName.substr(0,1).toUpperCase()}{lastName.substr(0,1).toUpperCase()}</div>;
};

export default Picture;
